<template>
  <page-header title="Отладка" icon="bi-wrench-adjustable"/>
  <div class="container d-flex flex-column gap-2">

    <f-loader ref="loader"/>
    <div class="d-flex gap-2 mb-2">
      <input v-model="projectId" type="text" class="form-control" placeholder="projectId">
      <button @click="onFindSessions" class="btn btn-primary text-nowrap">Поиск сессий</button>
    </div>
    <simple-table
        v-if="sessions"
        title="Незавершенные сессии"
        :items="sessions"
        :buttons="[{button: 'Терминировать все'}]"
        :format="[
            ['session_id'],
            ['nlu_url'],
            ['started_at', null, i=>unixToISO(i.started_at)],
            ['updated_at', null, i=>unixToISO(i.updated_at)],
            ['finished_at', null, i=>unixToISO(i.finished_at)],
        ]"
        @click-item="termSessions([$event])"
        @click-button="termSessions(sessions)"
    />
    <hr>
    <simple-table
        title="Сообщения в root exchange (все)"
        :search="true"
        :items="messages"
        :format="[
            ['routing_key', 'Routing key'],
            ['message', 'Сообщение', i=>JSON.stringify(i.message)],
        ]"
        :page-size="10"
        @click-item="onClickMessage"
    />

    <hr>

    <div class="form-text">
      Щелкните на принятом из очереди сообщении, чтобы скопировать routing_key из него.
      Выберите тип сообщения, чтобы сформировать routing_key и тело сообщения для ответа в соответствующем формате.
    </div>

    <div class="row">
      <div class="col">
        <label class="form-text mb-1">routing_key</label>
        <input v-model="routingKey" type="text" class="form-control" placeholder="routingKey">
      </div>
      <div class="col">
        <label class="form-text mb-1">Тип сообщения</label>
        <select v-model="msg_type" @change="onMsgTypeChange" class="form-select">
          <option value="msg">msg</option>
          <option value="hreq">hreq</option>
          <option value="btransfer">btransfer</option>
          <option value="term">term</option>
        </select>
      </div>
    </div>

    <textarea v-model="message" class="form-control" rows="6"/>
    <button v-if="connected" class="btn btn-outline-primary" @click="onSend">Отправить сообщение в root exchange</button>
    <button v-else class="btn btn-outline-dark" disabled>Disconnected</button>
  </div>
</template>

<script>
import {unixToISO, uuid4} from "@/misc/util";
import PageHeader from "@/components/PageHeader";
import SimpleTable from "@/components/simple-table/SimpleTable";
import FLoader from "@/components/FLoader";
import {http} from "@/misc/http";
import {auth} from "@/state/auth";

export default {
  components: {FLoader, SimpleTable, PageHeader},
  data() {
    return {
      connected: false,
      messages: [],
      msg_type: "msg",
      message: "",
      routingKey: "msg.user.web.fooproject.1.1",
      routingKeyBase: "msg.user.web.fooproject.1.1",
      projectId: "",
      sessions: null,
    }
  },

  created() {
    this.message = this.makeMessage({
      side: "operator",
      text: "Привет!",
    });
    const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
    this.socket = new WebSocket(protocol + window.location.host + "/api/developer_ws");
    this.socket.onopen = () => {
      this.socket.send(auth.token);
      this.connected = true;
    };
    this.socket.onclose = () => {
      this.connected = false;
    };
    this.socket.onmessage = (event) => {
      this.messages.unshift(JSON.parse(event.data));
    };
  },

  methods: {

    onSend() {
      this.socket.send(JSON.stringify({
        routing_key: this.routingKey,
        message: JSON.parse(this.message),
      }));
    },
    makeMessage(message) {
      return JSON.stringify({
        id: uuid4(),
        timestamp: Date.now() / 1000,
        ...message,
      }, null, 4);
    },

    formatMessage() {
      if (!this.routingKeyBase) return;
      const rk = this.routingKeyBase.split(".");
      let msg = {};
      switch (this.msg_type) {
        case "msg":
          rk[1] = "user";
          msg = {
            side: "operator",
            text: "Привет!",
          };
          break;

        case "hreq":
          rk[0] = "hreq";
          rk[1] = "ctl";
          rk.push("op");
          rk.push("0000");
          break;

        case "term":
          rk[0] = "term";
          rk[1] = "nlu";
          break;

        case "btransfer":
          rk[0] = "btransfer";
          rk[1] = "nlu";
          msg = {
            meta: {
              arm_var: "bar",
            },
          };
          break;
      }

      this.routingKey = rk.join(".");
      this.message = this.makeMessage(msg);

    },

    onClickMessage(message) {
      this.msg_type = "msg";
      this.routingKeyBase = message.routing_key;
      this.formatMessage();
    },

    onMsgTypeChange() {
      this.formatMessage();
    },

    onFindSessions() {
      this.$refs.loader.wrap(async () => {
        this.sessions = await http.get("/developer/sessions", {contains: this.projectId});
      });
    },

    termSessions(sessions) {
      this.$refs.loader.wrap(async () => {
        await http.post("/developer/sessions/term", sessions);
        this.sessions = await http.get("/developer/sessions", {contains: this.projectId});
      });
    },


    unixToISO,


  }
}
</script>

<style scoped>
.hovered:hover {
  background-color: bisque;
  cursor: pointer;
}

</style>